import React, { useEffect, useState } from 'react';
import { API } from '../../API/API';
import ButtonDefault from '../../components/ButtonDefault/ButtonDefault';
import FieldCheck from '../../components/FieldCheck/FieldCheck';
import ButtonSecondary from '../../components/ButtonSecondary/ButtonSecondary';
import LoadSpin from '../../components/LoadSpin/LoadSpin';
import { Col, Row } from 'antd';
import FieldNumberFormat from '../../components/FieldNumberFormat/FieldNumberFormat';
import { Modal } from '@fluentui/react';
import { corporateStrategyData } from '../../const/Const';

const DiwoAISetup = (props) => {

    const [data, setData] = useState([]);
    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [dataStrategy, setDataStrategy] = useState([]);

    const getData = async () => {
        let tData = [];
        try {
            setLoading(true);
            await API.get("/api/odata/ai").then(response => {
                if (response?.status == 200 && response?.data?.rettype == 0) {
                    if (response?.data?.retdata?.length > 0) {
                        tData = response?.data?.retdata;
                        tData.map(r => { if (r.value >= 0) { r.check = true; } });
                    }
                }
            });
        } finally {
            setLoading(false);
        }

        setData(tData);
    }

    useEffect(() => {
        getData();
    }, [])

    const fieldOnChanged = (pValue, pId, pField) => {
        let tData = [...data];
        let tIndex = tData?.map(r => r.id).indexOf(pId);
        if (tIndex >= 0) {
            tData[tIndex][pField] = pValue;
            if (pField == "value") {
                tData[tIndex].check = true;
            }
        }
        setData(tData);
    }


    const fieldOnChangedStrategy = (pValue, pId, pField) => {
        let tDataStrategy = [...dataStrategy];
        let tIndex = tDataStrategy?.map(r => r.key).indexOf(pId);
        if (tIndex >= 0) {
            tDataStrategy[tIndex][pField] = pValue;
        } else {
            let tConstDataStrategy = corporateStrategyData.find(r => r.key == pId);
            if (tConstDataStrategy) {
                tDataStrategy.push({
                    ...tConstDataStrategy,
                    "check": pValue
                });
            }
        }
        setDataStrategy(tDataStrategy);
    }

    const onSentData = () => {
        let tData = data?.filter(r => r.check && r.value >= 0);
        let tDataStrategy = dataStrategy?.filter(r => r.check);
        if (tData?.length > 0 && tDataStrategy?.length > 0 && props?.afterSent) {
            props?.afterSent(tData, tDataStrategy);
            setStep(1);
        }
    }

    const onNextStep = () => {
        setStep(r => r = r + 1);
    }

    const onPrevStep = () => {
        setStep(r => r = r - 1);
    }


    let vPanelLeft = null;
    let vPanelRight = null;

    if (step == 1 || step == 2) {
        vPanelLeft = (
            <div style={{ height: '90%', width: '80%', display: 'flex', flexDirection: 'column' }}>
                <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
                    <div className="circles" id="circles">
                        <div className="circle"></div>
                        <div className="circle"></div>
                        <div className="circle"></div>
                        <div className="circle"></div>
                    </div>
                </div>
                <div style={{ flex: 3, overflow: 'auto', borderRadius: 8, backgroundColor: '#FFFFFF', boxSizing: 'border-box', padding: 24 }}>
                    <div style={{ borderBottom: '1px solid #DEDEDE', paddingBottom: 12, fontSize: 16, fontWeight: 600 }}>
                        Байгууллагын стратегийн мэдээлэл ({dataStrategy?.filter(r => r.check && r.corporate)?.length})
                    </div>
                    <div>
                        {dataStrategy?.filter(r => r.check && r.corporate)?.length == 0 && (<div style={{ marginTop: 8, color: '#A39D97' }}>Байгууллагын стратеги сонгоогүй байна.</div>)}
                        {dataStrategy?.filter(r => r.check && r.corporate)?.map((r, index) => {
                            return (
                                <div key={index} style={{ marginTop: 8 }}>
                                    <div style={{ fontWeight: 600 }}>{r.text}</div>
                                    <div>{r.corporate}</div>
                                </div>
                            );
                        })}
                    </div>
                    <div style={{ borderBottom: '1px solid #DEDEDE', paddingBottom: 12, fontSize: 16, fontWeight: 600, marginTop: 32 }}>
                        Хүний нөөцийн стратегийн мэдээлэл  ({dataStrategy?.filter(r => r.check && r.hrsuite)?.length})
                    </div>
                    <div>
                        {dataStrategy?.filter(r => r.check && r.hrsuite)?.length == 0 && (<div style={{ marginTop: 8, color: '#A39D97' }}>Мэдээлэл байхгүй.</div>)}
                        {dataStrategy?.filter(r => r.check && r.hrsuite)?.map((r, index) => {
                            return (
                                <div key={index} style={{ marginTop: 8 }}>
                                    <div style={{ fontWeight: 600 }}>{r.text}</div>
                                    <div dangerouslySetInnerHTML={{ __html: r.hrsuite }}></div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }

    if (step == 1) {

        vPanelRight = (
            <div style={{ minWidth: 300 }}>
                <div style={{ fontSize: 20, fontWeight: 700 }}>Байгууллагын стратеги</div>
                <div style={{ marginTop: 8, marginBottom: 16, color: '#605E5C', fontSize: 14 }}>Танай байгууллагын стратегийн сонголт аль нь вэ? (Олон сонголттой байж болно)</div>
                {corporateStrategyData?.map((r, index) => {
                    return (
                        <div key={index}>
                            <Row gutter={[16, 16]} align={'middle'} justify={'space-between'}>
                                <Col span={24}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <FieldCheck onChanged={(key, text, field, fieldname) => fieldOnChangedStrategy(key, r?.key, field)} keyfield='check' defaultValue={dataStrategy?.find(ri => ri.key == r.key)?.check ? true : false} />
                                        <div style={{ marginLeft: 6, marginTop: 4 }}>
                                            {r?.text}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    );
                })}
                <div style={{ marginTop: 16, display: 'flex' }}>
                    <ButtonDefault onClick={onNextStep} disabled={dataStrategy?.filter(r => r.check).length > 0 ? false : true} text="Үргэлжлүүлэх" />
                </div>
            </div>
        );
    } else if (step == 2) {
        vPanelRight = (
            <div style={{ minWidth: 300, maxWidth: '80%' }}>
                <div style={{ fontSize: 20, fontWeight: 700 }}>Хүний нөөцийн үзүүлэлтүүд</div>
                <div style={{ marginTop: 8, marginBottom: 16, color: '#605E5C', fontSize: 14 }}>Diwo системд байгаа танай компаний тоонууд автоматаар гарч ирсэн. Харин манай системээс гарахгүй тоонуудыг та гараас оруулж өгнө үү. Аль болох олон үзүүлэлт оруулах, тоо нь бодит байх тусмаа хиймэл оюуны зөвлөгөө үр дүнтэй үүсгэгдэх болно.</div>
                {data?.map((r, index) => {
                    return (
                        <div key={index}>
                            <Row gutter={[16, 16]} align={'middle'} justify={'space-between'}>
                                <Col span={16}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <FieldCheck onChanged={(key, text, field, fieldname) => fieldOnChanged(key, r?.id, field)} keyfield='check' defaultValue={r?.check} />
                                        <div style={{ marginLeft: 6, marginTop: 4 }}>
                                            {r?.name}
                                        </div>
                                    </div>
                                </Col>
                                <Col span={8} >
                                    <FieldNumberFormat onChanged={(key, text, field, fieldname) => fieldOnChanged(key, r?.id, field)} keyfield='value' defaultValue={r?.value} />
                                </Col>
                            </Row>
                        </div>
                    );
                })}
                <div style={{ marginTop: 16, display: 'flex' }}>
                    <div style={{ marginRight: 16 }}>
                        <ButtonSecondary onClick={onPrevStep} text="Буцах" />
                    </div>
                    <ButtonDefault onClick={onSentData} disabled={data?.filter(r => r.check && r.value).length > 0 ? false : true} text="Илгээх" />
                </div>
            </div>
        );
    }

    return (
        <Modal
            isOpen={props?.isOpen}
            onDismiss={props?.onDismiss}
            containerClassName={{
                borderRadius: 8
            }}
        >
            <div style={{ height: '95vh', width: '95vw', display: 'flex' }}>
                <div className='setupLeftPanelContDiwo'>
                    <div className='setupLeftPanelDiwo'>
                        {vPanelLeft}
                    </div>
                </div>
                <div style={{
                    flex: 3,
                    overflow: 'auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: 32
                }}>
                    {loading ? <LoadSpin /> : vPanelRight}
                </div>
            </div>
        </Modal>
    );
}

export default DiwoAISetup;